import { render, staticRenderFns } from "./ProductReceiveDialog.vue?vue&type=template&id=b0617bc2&scoped=true&"
import script from "./ProductReceiveDialog.vue?vue&type=script&lang=js&"
export * from "./ProductReceiveDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductReceiveDialog.vue?vue&type=style&index=0&id=b0617bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0617bc2",
  null
  
)

export default component.exports